import React from 'react';
import { motion } from 'framer-motion';
import { formatDate } from '@/utils/date';

interface BlogContentProps {
  title: string;
  content: string;
  date: string;
  author: string;
  category: string;
  tags: string[];
}

export const BlogContent: React.FC<BlogContentProps> = ({
  title,
  content,
  date,
  author,
  category,
  tags
}) => {
  return (
    <motion.article 
      className="prose prose-invert max-w-none"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
    >
      <div className="mb-8">
        <div className="flex items-center space-x-4 text-sm text-gray-400 mb-4">
          <time dateTime={date}>{formatDate(date)}</time>
          <span>•</span>
          <span>{author}</span>
          <span>•</span>
          <span className="text-neon-green">{category}</span>
        </div>
        <h1 className="text-4xl font-bold mb-4">{title}</h1>
        <div className="flex flex-wrap gap-2">
          {tags.map(tag => (
            <span 
              key={tag}
              className="px-3 py-1 text-sm rounded-full bg-neon-green/20 text-neon-green"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
      
      <div 
        className="prose prose-invert prose-headings:text-neon-green prose-a:text-neon-purple"
        dangerouslySetInnerHTML={{ __html: content }} 
      />
    </motion.article>
  );
};